import React from 'react';

const PlayLimitMessage = ({ username, nextPlayTime, onBack }) => {
    const formatTime = (date) => {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const getTimeUntilNextPlay = () => {
        if (!nextPlayTime) return '';

        const now = new Date();
        const diff = nextPlayTime - now;
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        if (hours > 0) {
            return `${hours} saat ${minutes} dakika`;
        }
        return `${minutes} dakika`;
    };

    return (
        <div className="play-limit-message">
            <div className="neon-box limit-box">
                <div className="limit-icon">⏰</div>
                <h2 className="limit-title">Bugün Zaten Oynadın!</h2>
                <p className="username-display">@{username}</p>

                <div className="limit-info">
                    <p className="info-text">
                        Her kullanıcı <strong>günde 1 kez</strong> oynayabilir.
                    </p>
                    <p className="info-text">
                        Bu kural sayesinde herkes için adil bir yarışma sağlıyoruz! 🏆
                    </p>
                </div>

                <div className="next-play-time">
                    <h3 className="section-title">⏳ Tekrar Oynayabilirsin</h3>
                    <div className="time-display">
                        <div className="time-value">Yarın Saat 00:00</div>
                        <div className="countdown">({getTimeUntilNextPlay()} sonra)</div>
                    </div>
                </div>

                <div className="suggestions">
                    <h4 className="section-subtitle">Bu arada...</h4>
                    <ul className="suggestions-list">
                        <li>📊 Liderlik tablosuna bak</li>
                        <li>📱 Arkadaşlarını etiketle</li>
                        <li>🔔 Bildirimleri aç, yarın hatırlat</li>
                    </ul>
                </div>

                <div className="button-group">
                    <button className="neon-btn secondary back-btn" onClick={onBack}>
                        ← Ana Sayfaya Dön
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PlayLimitMessage;
